import { forwardRef, type InputHTMLAttributes } from 'react';

import { cn } from '@/lib/cn.js';

export type InputProps = InputHTMLAttributes<HTMLInputElement>;

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, ...rest }, ref) => (
    <input
      ref={ref}
      className={cn(
        'h-8 px-2.5 text-[13px] bg-ink-800 border border-ink-600 rounded-md placeholder:text-ink-400 focus-ring w-full transition-colors',
        className
      )}
      {...rest}
    />
  )
);
Input.displayName = 'Input';
